/* eslint-disable */
export default function homeReducer(state = {
  fetching: false,
  fetched: false,
  carousels_fetched: false,
  carousels_fetching: false,
  home_carousels: [],
  carousel_speed: 5,
  user: {},
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_CAROUSEL_PENDING': {
      return {
        ...state,
        fetching: true,
        fetch: false,
        fetched: false
      };
    }
    case 'GET_HOMEPAGE_CAROUSELS_PENDING':
      return {
        ...state,
        fetching: true,
        fetch: false,
        fetched: false,
        carousels_fetched: false,
        carousels_fetching: true,
      };

    case 'GET_HOMEPAGE_CAROUSELS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        home_carousels: action.payLoad.data,
        permissions: (action.payLoad.data.length > 0 && action.payLoad.data[0].hasOwnProperty('attributes'))
          ? action.payLoad.data[0].attributes.permissions :
          [],
        carousels_fetched: true,
        carousels_fetching: false,
      };
    }
    case 'GET_CAROUSEL_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        carousel: action.payLoad,
        saved: false,
      };
    }
    case 'GET_CAROUSEL_META_FULFILLED': {
      return {
        ...state,
        groups: action.payLoad.groups,
        articles: action.payLoad.articles
      }
    }
    case 'SET_CAROUSEL_SPEED':
      return {
        ...state,
        carousel_speed: action.payLoad
      };
    case 'SAVE_CAROUSEL_REJECTED':
    case 'GET_CAROUSEL_REJECTED':
    case 'GET_HOMEPAGE_CAROUSELS_REJECTED': {
      return {
        ...state,
        errors: action.payLoad
      };
    }
    default:
      return {...state};
  }
}
